// src/pages/admin/AdminTransactions.js
import React, { useState, useEffect } from 'react';
import api from '../../utils/api';

export default function AdminTransactions() {
  const [txns, setTxns] = useState([]);
  const [filter, setFilter] = useState({ type: '', status: '' });

  useEffect(() => { api.get('/admin/transactions', { params: filter }).then(r => setTxns(r.data.transactions || [])).catch(() => {}); }, [filter]);

  const typeColors = { BUY: 'green', SELL_LIST: 'cyan', EPA_SURRENDER: 'orange', SWAP: 'purple', ISSUANCE: 'yellow', DEPOSIT: 'cyan' };
  const totalVolume = txns.filter(t => t.type === 'BUY').reduce((s, t) => s + (t.total || 0), 0);

  return (
    <div>
      <div className="section-tag">Admin</div>
      <h1 className="section-title">ALL <span style={{ color: 'var(--neon-orange)' }}>TRANSACTIONS</span></h1>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '1rem', marginBottom: '2rem', marginTop: '1.5rem' }}>
        <div className="card" style={{ borderTop: '2px solid var(--neon-green)' }}>
          <div style={{ fontFamily: 'Space Mono, monospace', fontSize: '0.6rem', color: 'var(--muted)', letterSpacing: '2px' }}>TOTAL VOLUME</div>
          <div style={{ fontFamily: '"Plus Jakarta Sans", sans-serif', fontSize: '2rem', color: 'var(--neon-green)' }}>₹{(totalVolume / 100000).toFixed(1)}L</div>
        </div>
        <div className="card" style={{ borderTop: '2px solid var(--neon-cyan)' }}>
          <div style={{ fontFamily: 'Space Mono, monospace', fontSize: '0.6rem', color: 'var(--muted)', letterSpacing: '2px' }}>TOTAL COUNT</div>
          <div style={{ fontFamily: '"Plus Jakarta Sans", sans-serif', fontSize: '2rem', color: 'var(--neon-cyan)' }}>{txns.length}</div>
        </div>
        <div className="card" style={{ borderTop: '2px solid var(--neon-orange)' }}>
          <div style={{ fontFamily: 'Space Mono, monospace', fontSize: '0.6rem', color: 'var(--muted)', letterSpacing: '2px' }}>EPA SURRENDERED</div>
          <div style={{ fontFamily: '"Plus Jakarta Sans", sans-serif', fontSize: '2rem', color: 'var(--neon-orange)' }}>
            {txns.filter(t => t.type === 'EPA_SURRENDER').reduce((s, t) => s + t.qty, 0)} tCO₂e
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
        <select className="form-select" style={{ width: '160px' }} value={filter.type} onChange={e => setFilter(p => ({ ...p, type: e.target.value }))}>
          <option value="">All Types</option>
          <option>BUY</option><option>SELL_LIST</option><option>EPA_SURRENDER</option><option>SWAP</option><option>DEPOSIT</option>
        </select>
        <select className="form-select" style={{ width: '140px' }} value={filter.status} onChange={e => setFilter(p => ({ ...p, status: e.target.value }))}>
          <option value="">All Status</option>
          <option>settled</option><option>pending</option><option>surrendered</option>
        </select>
        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', fontFamily: 'Space Mono, monospace', fontSize: '0.65rem', color: 'var(--muted)' }}>{txns.length} records</div>
      </div>

      <div className="card">
        <div style={{ overflow: 'auto' }} className="thin-scroll">
          <table className="data-table" style={{ minWidth: '900px' }}>
            <thead><tr><th>Date</th><th>Type</th><th>Buyer</th><th>Seller</th><th>Credits</th><th>Price</th><th>Total</th><th>Fee</th><th>Status</th><th>TX Hash</th></tr></thead>
            <tbody>
              {txns.map(t => (
                <tr key={t.id}>
                  <td style={{ color: 'var(--muted)', fontSize: '0.65rem', whiteSpace: 'nowrap' }}>{new Date(t.created_at).toLocaleString('en-IN')}</td>
                  <td><span className={`badge badge-${typeColors[t.type] || 'muted'}`}>{t.type?.replace('_', ' ')}</span></td>
                  <td style={{ fontSize: '0.7rem' }}>{t.buyer_name || '—'}</td>
                  <td style={{ fontSize: '0.7rem' }}>{t.seller_name || '—'}</td>
                  <td style={{ fontFamily: 'Space Mono, monospace' }}>{t.qty} tCO₂e</td>
                  <td>{t.price ? `₹${t.price.toLocaleString()}` : '—'}</td>
                  <td style={{ color: 'var(--neon-green)' }}>{t.total ? `₹${t.total.toLocaleString()}` : '—'}</td>
                  <td style={{ color: 'var(--muted)' }}>{t.fee ? `₹${t.fee.toLocaleString()}` : '—'}</td>
                  <td><span className={`badge badge-${t.status === 'settled' || t.status === 'surrendered' ? 'green' : 'yellow'}`}>{t.status}</span></td>
                  <td style={{ color: 'var(--muted)', fontSize: '0.6rem', fontFamily: 'Space Mono, monospace' }}>{t.tx_hash}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
